module.exports = __webpack_public_path__ + "static/media/217-Abspann_ID_4.7806a72c.mp3";